<script setup lang="ts">
import type { IconName } from '@camelot/components'
import { CtIcon } from '@camelot/components'

const props = defineProps<{
  title: string
  text: string
  icon: IconName
}>()
</script>

<template>
  <li class="flex flex-row shrink-0 basis-3/4 snap-start">
    <CtIcon :name="icon" size="32" class="flex-none mr-8" />
    <div>
      <h4 class="my-4 text-sm">
        {{ props.title }}
      </h4>
      <p class="text-sm">
        {{ props.text }}
      </p>
    </div>
  </li>
</template>
